// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  assistant: {
    name: 'assistant',
    componentName: 'Assistant',
    chunk: () => import(
      /* webpackChunkName: "assistant" */
      './pages/Assistant'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Assistant.js')).Assistant
        : currentRouteName === 'assistant'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Assistant })));
    },
    path: '/:context?/magic-apron/assistant',
    channel: null
  }
});
